import React from "react";
import { HiOutlineX } from "@react-icons/all-files/hi/HiOutlineX";
import StatusBadge from "./StatusBadge";

export interface AuditEntry {
  id: string | number;
  actor: string;
  action: string;
  target: string;
  before?: string | null;
  after?: string | null;
  created_at: string;
}

interface AuditTrailDrawerProps {
  open: boolean;
  onClose: () => void;
  entries: AuditEntry[];
}

const AuditTrailDrawer: React.FC<AuditTrailDrawerProps> = ({ open, onClose, entries }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex justify-end bg-black/30 backdrop-blur-sm">
      <div className="h-full w-full max-w-lg border-l border-surface-border bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-surface-border px-4 py-3">
          <div>
            <p className="text-sm font-semibold text-ink">操作ログ</p>
            <p className="text-xs text-muted">誰が・いつ・何を・どう変えたか</p>
          </div>
          <button
            onClick={onClose}
            className="rounded-full p-2 text-muted transition hover:bg-surface-alt hover:text-ink"
            aria-label="close"
          >
            <HiOutlineX className="h-5 w-5" />
          </button>
        </div>

        <div className="max-h-[calc(100vh-60px)] overflow-y-auto p-4 space-y-3">
          {entries.length === 0 && (
            <p className="text-sm text-muted">まだ操作ログはありません。</p>
          )}

          {entries.map((entry) => (
            <div key={entry.id} className="rounded-xl border border-surface-border bg-surface-alt p-3">
              <div className="flex items-center justify-between">
                <div className="font-semibold text-ink">{entry.actor}</div>
                <span className="text-xs text-muted">{entry.created_at}</span>
              </div>
              <div className="mt-1 text-sm text-ink">{entry.action}</div>
              <div className="mt-1 text-xs text-muted">対象: {entry.target}</div>
              {(entry.before || entry.after) && (
                <div className="mt-2 grid grid-cols-2 gap-2 text-xs">
                  <div className="rounded-lg bg-white p-2 shadow-inner">
                    <p className="text-[10px] uppercase text-muted">Before</p>
                    <p className="break-words text-ink opacity-80">{entry.before || "-"}</p>
                  </div>
                  <div className="rounded-lg bg-white p-2 shadow-inner">
                    <p className="text-[10px] uppercase text-muted">After</p>
                    <p className="break-words text-ink opacity-80">{entry.after || "-"}</p>
                  </div>
                </div>
              )}
              <div className="mt-2 flex items-center gap-2">
                <StatusBadge label="監査ログ" tone="blue" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuditTrailDrawer;
